/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><div ref="__mpx_ref_container__" :class="({'hide-refund': !!order.hideNum && hideRefund})" class="train-order-information-ticket"><template v-for="(item, index) in (orderList)"><div :class="({'less-bottom': item.showStatus && !(item.isRefunding || item.isChanging)})" class="item"><div :class="({'gray': !order.isAllGray && item.isGray})" :style="[({'margin-bottom': item.showStatus && !item.status_name ? '5px' : '0'})] | transRpxStyle" class="left"><div class="top"><div class="name">{{ item.passenger_name }}</div><div class="state-card"><div class="card" v-if="(item.ticket_type)">{{ getType(item) }}</div></div><div class="price-seat" v-if="(!item.showStatus)"><div class="seat-type">{{ item.seat_type }}</div><div class="seat-price">{{ price(item) }}</div></div></div><div class="bottom" v-if="(item.showStatus)"><div class="seat-type">{{ item.seat_type }}</div><div class="seat-price">{{ price(item) }}</div></div></div><div class="right"><div :class="({'gray': !order.isAllGray && item.isGray})" class="top" v-if="((showSeatStatus.includes(item.status) || item.showStatus || tickets12306) && getSeatText(item))"><div class="card" v-if="(item.is_beside_window)">靠窗</div><div class="card" v-if="(item.special_flag)">静</div><div>{{ getSeatText(item) }}</div></div><div :class="({'gray': !order.isAllGray && item.isGray})" class="top" v-else-if="(item.status_name)">{{
            item.status_name
          }}</div><div :class="({'more-top': item.isRefunding || item.isChanging, 'no-top': !item.status_name})" class="status-wrapper" v-if="(item.showStatus)"><mpx-view @tap="toRefundPage(item)" class="status-btn" v-if="(item.isRefunded)">退票详情</mpx-view><mpx-view @tap="toChangePage(item)" class="status-btn" v-if="(item.newChange)">改签详情</mpx-view><mpx-view @tap="invokeDrawer(item, 'refund')" class="status-btn" v-if="(item.canRefund && !item.waitingPay)">退票</mpx-view><mpx-view @tap="invokeDrawer(item, 'change')" class="status-btn" v-if="(item.canChange && !item.waitingPay)">改签</mpx-view><div class="status-btn paid" v-if="(item.waitingPay)">待支付</div><div class="status-btn text" v-if="(item.isRefunding || item.isChanging)">{{item.status_name ?? ''}}</div></div></div></div></template></div><mpx-view @tap="showAllTicket" class="remainder" v-if="(order.hideNum && hideRefund)">查看剩余{{order.hideNum}}名乘客</mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m0071e325"}'>
  @import '~@/mixins/stylus/color.styl'

  .train-order-information-ticket
    background #D2E6FF
    border-radius 0 0 10px 10px
    transition height 0.3s linear
    overflow hidden
    &.hide-refund
      border-radius 0
    .item
      display flex
      box-sizing border-box
      position relative
      padding 14px 16px
      justify-content space-between
      &.less-bottom
        padding-bottom 9px
      .left
        display flex
        flex-direction column
        .top
          display flex
          align-items center
          .name
            font-family PingFangSC-Medium
            font-size 15px
            line-height 15px
            color #222
          .state-card
            display flex
            align-items center
          .price-seat
            display flex
            .seat-type
              color #666
              margin-left 4px
              line-height 13px
              font-size 13px
            .seat-price
              line-height 13px
              font-size 13px
              color #666
              margin-left 2px
        .bottom
          margin-top 12px
          display flex
          font-family PingFangSC-Regular
          font-size 13px
          line-height 13px
          color #222
          .seat-price
            margin-left 4px
      .right
        display flex
        flex-direction column
        justify-content space-between
        .top
          font-family PingFangSC-Medium
          font-size 15px
          line-height 15px
          color #222
          display flex
          flex-direction row-reverse
        .bottom
          margin-top 12px
        .status-wrapper
          display flex
          flex-direction row-reverse
          margin-top 8px
          &.more-top
            margin-top 10px
          &.no-top
            margin-top 0
          .status-btn
            padding 5px 12px
            box-sizing border-box
            display flex
            flex-direction row-reverse
            line-height 12px
            font-size 12px
            font-family PingFangSC-Regular
            font-weight 400
            background #fff
            color #338FFF
            border-radius 50px
            &:not(:last-child)
              margin-left 5px
            &.paid
              color #FF6400
            &.text
              font-size 15px
              font-family PingFangSC-Medium
              font-weight 500
              line-height 15px
              padding 0
              background transparent
      &:not(:last-child)
        &::after
          position absolute
          content ''
          width 646px
          height 1px
          background #B0D3FF
          box-sizing border-box
          transform-origin 0 0
          transform scale(0.5) translate(-50%)
          border-radius 12px
          bottom 0
          left 50%
  .card
    position relative
    box-sizing border-box
    padding 2px
    margin-left 4px
    border-radius 3px
    font-family PingFangSC-Regular
    font-size 10px
    line-height 10px
    color #5F88C8
    &::after
      position absolute
      content ''
      width 200%
      height 200%
      box-sizing border-box
      border 1px solid #5F88C8
      transform-origin 0 0
      transform scale(0.5)
      border-radius 6px
      top 0
      left 0
  .gray
    opacity 0.6
  .label
    margin-right 9px
    font-size 13px
    line-height 13px
  .remainder
    position relative
    background #D2E6FF
    padding 10px 0
    text-align center
    line-height 12px
    border-radius 0 0 10px 10px
    font-size 12px
    color #5F88C8
    &::before
      position absolute
      content ''
      width 646px
      height 1px
      background #B0D3FF
      box-sizing border-box
      transform-origin 0 0
      transform scale(0.5) translate(-50%)
      border-radius 12px
      top 0
      left 50%
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0071e325"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex0071e325%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex0071e325%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0071e325"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index0071e325/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
